class AddToWishlist extends HTMLElement {
  constructor() {
    super();
    this.addButton = this.querySelector(".add-to-wishlist-button");
    this.productJson = this.querySelector(".wishlist-product-json");
    this.productTextContent = this.productJson?.textContent;
    this.productJsonParsed = JSON.parse(this.productTextContent);
    this.productId = this.productJsonParsed.id;
    this.addButton?.addEventListener("click", this.handleWishlist.bind(this));
    this.checkWishlistCookie();
  }

  checkWishlistCookie() {
    let wishlistExists = this.wishlistExists();
    if (wishlistExists) {
      let wishlistCookie = getCookie("glamkeywishlist");
      let wishlistCookieParsed = JSON.parse(wishlistCookie);
      if (
        wishlistCookieParsed.some((product) => product.id == this.productId)
      ) {
        this.addButton?.classList.add("fill");
      }
    }
  }

  handleWishlist() {
    let wishlistExists = this.wishlistExists();
    if (wishlistExists) {
      let wishlistCookie = getCookie("glamkeywishlist");
      let wishlistCookieParsed = JSON.parse(wishlistCookie);
      if (
        wishlistCookieParsed.some((product) => product.id == this.productId)
      ) {
        let updatedWishlist = wishlistCookieParsed.filter(
          (product) => product.id != this.productId
        );

        this.removeFromWishlist(updatedWishlist);
        return;
      }
      wishlistCookieParsed.push(this.productJsonParsed);
      this.addToWishlist(wishlistCookieParsed);
    } else {
      let wishlistArray = [];
      wishlistArray.push(this.productJsonParsed);
      this.addToWishlist(wishlistArray);
    }

    let wishlistNotification = document.getElementById("wishlist-notification");
    wishlistNotification?.classList.add("active");
    setTimeout(() => {
      wishlistNotification?.classList.remove("active");
    }, 10000);
  }

  addToWishlist(wishlist) {
    setCookie("glamkeywishlist", JSON.stringify(wishlist), 400);
    this.addButton?.classList.add("fill");
  }

  removeFromWishlist(wishlist) {
    setCookie("glamkeywishlist", JSON.stringify(wishlist), 400);
    this.addButton?.classList.remove("fill");
  }

  wishlistExists() {
    return getCookie("glamkeywishlist") ? true : false;
  }
}
customElements.define("add-to-wishlist", AddToWishlist);

class WishlistPage extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("wishlist-page", WishlistPage);

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

let wishlist = document.getElementById("wishlist");
let wishlistSectionId = wishlist?.dataset.sectionId;

if (wishlist) {
  renderWishlist();
  async function renderWishlist() {
    let wishlistGrid = document.querySelector("#wishlist .grid");
    let wishlistCookie = getCookie("glamkeywishlist");
    if (wishlistCookie == "") {
      wishlistGrid.innerHTML = window.wishlistStrings.empty;
      return;
    }
    let wishlistCookieParsed = JSON.parse(wishlistCookie);
    let wishlistProducts = wishlistCookieParsed;
    wishlistProducts = await wishlistCookieParsed.map((product, index) => {
      return `<li
        id="Slide-${wishlistSectionId}-${index + 1}"
        class="grid__item slider__slide scroll-trigger animate--slide-in"
        data-cascade=""
        style="--animation-order: ${index + 1};"
      >
      <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
          <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 125.0%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <img
                  srcset="${product.image}&amp;width=165 165w,${
        product.image
      }&amp;width=360 360w,${product.image}&amp;width=533 533w,${
        product.image
      }&amp;width=720 720w,${product.image}&amp;width=940 940w,${
        product.image
      }&amp;width=1066 1066w,${product.image} 3493w"
                  src="${product.image}&amp;width=533"
                  sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                  alt="${product.title}"
                  class="motion-reduce"
                  loading="lazy"
                  width="3493"
                  height="3756"
                >
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a
                    href="${product.url}"
                    id="StandardCardNoMediaLink-${wishlistSectionId}"
                    class="full-unstyled-link"
                    aria-labelledby="StandardCardNoMediaLink-${wishlistSectionId} NoMediaStandardBadge-${wishlistSectionId}"
                  >
                    ${product.title}
                  </a>
                </h3>
              </div>
              <div class="card__badge bottom left"></div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5" id="title-${wishlistSectionId}">
                <a
                  href="${product.url}"
                  id="CardLink-${wishlistSectionId}"
                  class="full-unstyled-link"
                  aria-labelledby="CardLink-${wishlistSectionId} Badge-${wishlistSectionId}"
                >
                  ${product.title}
                </a>
              </h3>
              <div class="card-information">
                <span class="caption-large light"></span>
                <div
                  class="    price"
                >
                  <div class="price__container">
                    ${product.price}
                  </div>
                </div>
              </div>
            </div>
            <div class="quick-add no-js-hidden">
              <remove-from-wishlist-button>
                <button class="remove-from-wishlist-button button button--secondary" data-product-id="${
                  product.id
                }">${window.wishlistStrings.remove}</button>
              </remove-from-wishlist-button>
            </div>
          </div>
        </div>
      </div>
    </li>`;
    });
    wishlistGrid.innerHTML = wishlistProducts.join("");
  }

  wishlist.addEventListener("click", (e) => {
    if (e.target.classList.contains("remove-from-wishlist-button")) {
      let wishlistCookie = getCookie("glamkeywishlist");
      let wishlistCookieParsed = JSON.parse(wishlistCookie);
      let productId = e.target.dataset.productId;
      let updatedWishlist = wishlistCookieParsed.filter(
        (product) => product.id != productId
      );
      setCookie("glamkeywishlist", JSON.stringify(updatedWishlist), 400);
      if (updatedWishlist.length == 0) {
        let wishlistGrid = document.querySelector("#wishlist .grid");
        wishlistGrid.innerHTML = window.wishlistStrings.empty;
        return;
      }
      renderWishlist();
    }
  });
}

class WishlistNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("wishlist-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "wishlist-notification-product",
        selector: `[id="wishlist-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "wishlist-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("wishlist-notification")
    ) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("wishlist-notification", WishlistNotification);
